export default __webpack_public_path__ + "static/media/web_meeting.af557b11.svg";